<div class="ui-modal share-group-dialog">
  <div class="header flex-row space-between-center">
    <div>{{ 'PERSON_GROUPS.SHARE_DIALOG.TITLE' | translate: { name: data.groupName } }}</div>
    <span class="ui-icon-close c-p" (click)="onClose()" tabindex="0" role="button"></span>
  </div>

  <div class="body flex-col gap-16">
    <div class="people-with-access flex-col gap-8 flex-1 min-h-0">
      @if (personGroupShareOptionsLoading()) {
        <div class="w-100 h-100 flex-1 min-h-0">
          <ui-preloader [color]="loaderColor.blue"></ui-preloader>
        </div>
      } @else {
        <div class="flex-col gap-4">
          <label class="share-field-label">{{ 'PERSON_GROUPS.SHARE_DIALOG.ACCESS_TYPE' | translate }}</label>
          <mat-form-field appearance="outline" class="w-100 mat-form-field-ui-selector compact-select-field">
            <mat-select
              [value]="accessTypeSelectValue()"
              [disabled]="isShareEditingLocked()"
              (selectionChange)="onAccessTypeChange($event)">
              @for (role of availableInviteRoles(); track role) {
                <mat-option [value]="role">{{
                    PersonGroupsModel.shareAccessTypeTranslationKey(role) | translate
                  }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-col gap-4">
          <label class="share-field-label">{{ 'PERSON_GROUPS.SHARE_DIALOG.SHARED_CODE' | translate }}</label>
          <div class="share-code-row">
            <div class="share-code-input-wrapper">
              <input class="ui-input share-code-input" readonly [value]="personGroupInviteCode() ?? ''" />
              @if (isInviteCodeLoading()) {
                <ui-preloader
                  class="share-code-input-loader"
                  [color]="loaderColor.blue"
                  [diameter]="18"></ui-preloader>
              }
            </div>
            @if (personGroupInviteCode()) {
              <ui-button
                type="default"
                iconClass="ui-icon-copy1"
                [matTooltip]="'COMMON.COPY' | translate"
                [attr.aria-label]="'COMMON.COPY' | translate"
                [disabled]="isInviteCodeLoading()"
                (clickAction)="copyInviteCode()">
              </ui-button>
              <ui-button
                type="default"
                iconClass="ui-icon-share"
                [matTooltip]="'PERSON_GROUPS.SHARE_DIALOG.SHARE_NATIVE' | translate"
                [attr.aria-label]="'PERSON_GROUPS.SHARE_DIALOG.SHARE_NATIVE' | translate"
                [disabled]="isInviteCodeLoading()"
                (clickAction)="shareCode()">
              </ui-button>
            }
          </div>
        </div>

        <div class="flex-col gap-4">
          <label class="share-field-label">{{ 'PERSON_GROUPS.SHARE_DIALOG.PEOPLE_WITH_ACCESS' | translate }}</label>
          <div class="filters-wrapper">
            <ui-search
              [searchQuery]="memberSearch()"
              (onInput)="memberSearch.set($event)"
              [placeholder]="'PERSON_GROUPS.SHARE_DIALOG.SEARCH_PLACEHOLDER' | translate">
            </ui-search>
          </div>
        </div>
        @switch (viewState()) {
          @case (viewStates.HAS_CONTENT) {
            <ui-dataset-table [data]="filteredSharedWithOrgs()" [config]="tableConfig()"></ui-dataset-table>
          }
          @case (viewStates.NO_RESULTS) {
            <ui-no-data
              [imgSrc]="shareDialogNoResults.imgSrc"
              [title]="shareDialogNoResults.title | translate">
            </ui-no-data>
          }
          @case (viewStates.INITIAL_EMPTY) {
            <ui-no-data
              [imgSrc]="shareDialogInitialEmpty.imgSrc"
              [title]="shareDialogInitialEmpty.title | translate">
            </ui-no-data>
          }
        }
      }
    </div>
  </div>
</div>

<ng-template #actionsCell let-row="row">
  <div (click)="$event.stopPropagation()" class="shared-with-actions-cell">
    <div class="loader-wrapper">
      @if (isUpdatingAccessForOrg(row.orgId)) {
        <ui-preloader [color]="loaderColor.blue" [diameter]="20"></ui-preloader>
      }
    </div>
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="member-role-field flex-1 min-w-0 mat-form-field-ui-selector compact-select-field">
      <mat-select
        #rowRoleSelect
        [value]="row.accessType"
        [disabled]="isUpdatingAccessForOrg(row.orgId) || isShareEditingLockedForOrg(row)"
        (selectionChange)="onAccessListItemChange(row, $event)">
        @for (role of personGroupAccessRoles(); track role) {
          <mat-option [value]="role">{{
              PersonGroupsModel.shareAccessTypeTranslationKey(role) | translate
            }}
          </mat-option>
        }
        @if (!isShareEditingLockedForOrg(row)) {
          <div class="remove-org-divider"></div>
          <div
            class="remove-org-option"
            role="button"
            tabindex="0"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
            (click)="removeOrgFromOption(row, rowRoleSelect, $event)"
            (keydown.enter)="removeOrgFromOption(row, rowRoleSelect, $event)"
            (keydown.space)="removeOrgFromOption(row, rowRoleSelect, $event)">
            <span class="ui-icon-delete"></span>
            {{ 'PERSON_GROUPS.SHARE_DIALOG.REMOVE_ORGANIZATION' | translate }}
          </div>
        }
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>
